import React from 'react';

export const EMOJI_CDN = 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple@15.1.2/img/apple/64/';
const RE = /(\p{Extended_Pictographic}(?:\uFE0F|[\u{1F3FB}-\u{1F3FF}])*(?:\u200D\p{Extended_Pictographic}(?:\uFE0F|[\u{1F3FB}-\u{1F3FF}])*)*|[\u{1F1E6}-\u{1F1FF}]{2})/gu;
const code = (e) => [...e].map((c) => c.codePointAt(0).toString(16)).join('-');

const Emo = ({ e, size }) => {
  const full = code(e);
  const tries = [...new Set([full, full.replace(/-fe0f/g, ''), full.includes('fe0f') ? null : `${full}-fe0f`].filter(Boolean))];
  const onError = (ev) => {
    const img = ev.currentTarget;
    const i = Number(img.dataset.i || 0) + 1;
    if (i < tries.length) { img.dataset.i = String(i); img.src = `${EMOJI_CDN}${tries[i]}.png`; return; }
    const span = document.createElement('span');
    span.textContent = e; span.style.fontSize = size;
    img.replaceWith(span);
  };
  return <img src={`${EMOJI_CDN}${tries[0]}.png`} alt={e} draggable={false} onError={onError} className="inline-block align-[-0.25em] mx-[1px]" style={{ width: size, height: size }} />;
};

export const onlyEmojis = (t) => !!t && t.replace(RE, '').trim() === '' && (t.match(RE) || []).length <= 3;

// Mostra os emojis no estilo Apple/WhatsApp em qualquer computador ou telemóvel
export const EmojiText = ({ text, size = '1.35em' }) => {
  if (!text) return null;
  const parts = text.split(RE);
  return parts.map((p, i) => (i % 2 === 1 && !/^[\u00A9\u00AE\u2122\u2194-\u21AA]$/.test(p) ? <Emo key={i} e={p} size={size} /> : <React.Fragment key={i}>{p}</React.Fragment>));
};
